import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/index';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root' // TODO: Consider if we should provide only in admin module (how?)
})
// TODO: Rename/move to an AccountsService or AdminAccountsService
export class AdminCommonService {

    constructor(private httpClient: HttpClient) {
    }

    getAvailableUserStatuses(): Observable<any> {
        return this.httpClient
            .get<{ userStatuses: Array<String> }>('servlets/satellites/userstatuses/', {observe: 'body'})
            .pipe(
                map((response: any) => response.userStatuses)
            );
    }

}
